import { BaseVO } from './BaseVO';

export class MediaPlanVO extends BaseVO {
    budget: number;
    demoCpm: number;
    demoImpressions: number;
    targetCpm: number;
    targetImpressions: number;
    totalCpm: number;
    totalImpressions: number;
    currency: string;
    status: string;
    downloadLink: string;
    downloadFileName: string;
}
